import React, {useContext, useEffect, useState} from 'react';
import Sidebar from "../components/Sidebar";
import {Outlet, useLocation} from "react-router";
import ProfileIcon from "../components/ProfileIcon";
import classes from './Main.module.scss';
import {Context} from "../index";
import {observer} from "mobx-react-lite";
import {getChannels} from "../http/channelAPI";
import {getDevices, getVoltage} from "../http/deviceAPI";

const Main = observer(() => {
    const {user} = useContext(Context);
    const {channels} = useContext(Context);
    const {things} = useContext(Context);
    const {ui} = useContext(Context);
    const {analytics} = useContext(Context);
    const [serialNumber, setSerialNumber] = useState('')
    const [model, setModel] = useState('')
    const [offline, setOffline] = useState(false)
    const [online, setOnline] = useState(false)
    const location = useLocation();

    useEffect(() => {

        const gch = async () => {
            try {
                const data = await getChannels();
                const channelId = data.data.channels.filter(({name}) => {
                    if (name === 'main') {
                        return true
                    }
                })
                channelId.length > 0 && channels.setChannelId(channelId[0].id)
            } catch (e) {
            }
        }
        gch().then(async () => {
            const data = await getDevices();
            data.data.things.filter((item) => {
                if (item.name === 'gate') {
                    things.setGate('id', item.id)
                    things.setGate('key', item.key)
                }
            })
        })
    }, [])

    const resetFilter = () => {
        setSerialNumber('')
        setModel('')
        setOnline(false)
        setOffline(false)
    }

    useEffect(() => {
        ui.setIsDeviceList(false)
        const load = async () => {
            try {
                if (channels.channelId !== null) {
                    let i = 0
                    for (const name of things.data) {
                        const {data} = await getVoltage(name.name, channels.channelId, (+new Date() - 180000) / 1000, +new Date() / 1000)
                        data.total > 0 ? things.setIsOnline(i++, true) : things.setIsOnline(i++, false)
                    }
                }
            } catch (e) {
            }
        }
        load().then(() => {
            ui.setIsDeviceList(true)
        })
    }, [things.data])

    const offlineFilter = async () => {
        let a = things.data
        let b = [];
        if (offline) {
            a.map((item) => {
                if (item.isOnline === false) {
                    b.push(item)
                }
            })
            things.setData(b)
        } else {
            try {
                const {data} = await getDevices();
                things.setData(data.things.map((item) => {
                    return {
                        id: item.id,
                        key: item.key,
                        name: item.name,
                        model: item.name.slice(18, 23),
                        serialNumber: item.name.slice(24),
                        isOnline: false,
                        equipment: item.metadata.equipment,
                        settings: item.metadata.settings

                    }
                }).filter((item) => {
                    if (item.name !== 'gate') return true
                }).sort((a, b) => a.name > b.name ? 1 : -1))
            } catch (e) {
            }
        }
    }

    useEffect(() => {
        offlineFilter().then(null)
    }, [offline])

    const onlineFilter = async () => {
        let a = things.data
        let b = [];
        if (online) {
            a.map((item) => {
                if (online && item.isOnline) {
                    b.push(item)
                }
            })
            things.setData(b)
        } else {
            try {
                const {data} = await getDevices();
                things.setData(data.things.map((item) => {
                    return {
                        id: item.id,
                        key: item.key,
                        name: item.name,
                        model: item.name.slice(18, 23),
                        serialNumber: item.name.slice(24),
                        isOnline: false,
                        equipment: item.metadata.equipment,
                        settings: item.metadata.settings

                    }
                }).filter((item) => {
                    if (item.name !== 'gate') return true
                }).sort((a, b) => a.name > b.name ? 1 : -1))
            } catch (e) {
            }
        }
    }

    useEffect(() => {

        onlineFilter().then(null)
    }, [online])

    const snFilter = async (e) => {

        things.setData([]);
        try {
            const {data} = await getDevices();
            things.setData(data.things.map((item) => {
                return {
                    id: item.id,
                    key: item.key,
                    name: item.name,
                    model: item.name.slice(18, 23),
                    serialNumber: item.name.slice(24),
                    isOnline: false,
                    equipment: item.metadata.equipment,
                    settings: item.metadata.settings

                }
            }).filter((item) => {
                if (item.name !== 'gate') return true
            }).filter((item) => {
                if (item.serialNumber.includes(serialNumber.toString())) {
                    return item
                }
            }).sort((a, b) => a.name > b.name ? 1 : -1))
        } catch (e) {
            things.setData([]);
        }
    }

    useEffect(() => {
        snFilter().then(null)
    }, [serialNumber])

    const modelFilter = async (e) => {
        try {
            const {data} = await getDevices();
            things.setData(data.things.map((item) => {
                return {
                    id: item.id,
                    key: item.key,
                    name: item.name,
                    model: item.name.slice(18, 23),
                    serialNumber: item.name.slice(24),
                    isOnline: false,
                    equipment: item.metadata.equipment,
                    settings: item.metadata.settings
                }
            }).filter((item) => {
                if (item.name !== 'gate') return true
            }).filter((item) => {
                if (item.model === model) {
                    return item
                } else {
                    return item
                }
            }).sort((a, b) => a.name > b.name ? 1 : -1))
        } catch (e) {
        }
    }
    useEffect(() => {
        modelFilter().then(null)
    }, [model])

    const [list, setList] = useState([])
    const [focus, setFocus] = useState(false)
    const [filterList, setFilterList] = useState(things.data)


    const deleteItem = (item) => {
        const array = list
        for (let i = 0; i < array.length; i++) {
            if (array[i].serialNumber === item.serialNumber) {
                array.splice(i, 1)
            }
        }
        setList(array)
        setList(list.filter(i => i.serialNumber !== item.serialNumber))
        analytics.setFetchList(list)
    }



    const toggleFocus = () => {
        setFilterList(things.data)
        setFocus(true)
        setFilterList(() => {
            return things.data.filter((item) => {
                for (let i = 0; i < list.length; i++) {
                    if (list[i].serialNumber === item.serialNumber.toString()) {
                        return false
                    }
                }
                return item
            })
        })
    }

    const toggleBlur = () => {
        setTimeout(() => {
            setFocus(false)
            setSerialNumber('')
        }, 100)
    }

    const addItemFilter = (item) => {
        const array = list
        array.push(item)
        setList(array)
        analytics.setFetchList(list)
        setSerialNumber('')
    }

    useEffect(() => {
        if (location.pathname === '/analytics') {
            setList([])
            analytics.setFetchList([])
        }
    }, [location.pathname]);

    return (
        <>
            <div className="container">
                <div>
                    <Sidebar/>
                </div>
                <div className="main-wrapper">
                    <Outlet/>
                </div>
                <div className="rightbar">
                    <div className="top">
                        <ProfileIcon email={user.user.email}/>
                    </div>
                    {location.pathname === '/things' &&
                        <div className={classes.advanced}>
                            <div className={classes.name}>Фильтры</div>
                            <input className={classes.filter} value={serialNumber}
                                   onChange={e => setSerialNumber(e.target.value)}
                                   placeholder={'Серийный номер'} type="number"/>
                            <select className={classes.filter} onChange={e => setModel(e.target.value)} value={model}
                                    style={model === '' ? {color: '#757575'} : {color: 'black'}}>
                                <option disabled hidden value={''}>Модель</option>
                                <option value='tl101'>TL101</option>
                            </select>

                            <div className={classes.buttonGroup}>
                                <button value={online} disabled={offline ? 'disabled' : null}
                                        onClick={() => online ? setOnline(false) : setOnline(true)}
                                        className={classes.online}>Online
                                </button>
                                <hr/>
                                <button value={offline} disabled={online ? 'disabled' : null}
                                        onClick={() => offline ? setOffline(false) : setOffline(true)}
                                        className={classes.offline}>Offline
                                </button>

                            </div>

                            <button className={classes.resetBtn} onClick={resetFilter}>Очистить</button>
                        </div>}
                    {location.pathname.includes('urn:dev:ops') &&
                        <div className={classes.advanced}>
                            <div className={classes.name}>Фильтры</div>
                            <button value={ui.isVoltage}
                                    onClick={() => ui.isVoltage ? ui.setIsVoltage(false) : ui.setIsVoltage(true)}
                                    className={classes.voltage}>Напряжение
                            </button>
                            <button value={ui.isCurrent}
                                    onClick={() => ui.isCurrent ? ui.setIsCurrent(false) : ui.setIsCurrent(true)}
                                    className={classes.current}>Ток
                            </button>
                            <button value={ui.isTemperature}
                                    onClick={() => ui.isTemperature ? ui.setIsTemperature(false) : ui.setIsTemperature(true)}
                                    className={classes.temperature}>Температура
                            </button>
                            <button value={ui.isHumidity}
                                    onClick={() => ui.isHumidity ? ui.setIsHumidity(false) : ui.setIsHumidity(true)}
                                    className={classes.humidity}>Влажность
                            </button>
                            <button value={ui.isPower}
                                    onClick={() => ui.isPower ? ui.setIsPower(false) : ui.setIsPower(true)}
                                    className={classes.power}>Мощность
                            </button>
                            <button value={ui.isEvent}
                                    onClick={() => ui.isEvent ? ui.setIsEvent(false) : ui.setIsEvent(true)}
                                    className={classes.event}>События
                            </button>
                            <button value={ui.isMap}
                                    onClick={() => ui.isMap ? ui.setIsMap(false) : ui.setIsMap(true)}
                                    className={classes.event}>Карта
                            </button>
                        </div>}
                    {location.pathname === '/analytics' &&
                        <div className={classes.advanced}>
                            <div className={classes.name}>Фильтры</div>
                            <div className={classes.fetchFilterWrapper}>
                                <input onFocus={toggleFocus} onBlur={toggleBlur} className={classes.fetchFilter}
                                       value={serialNumber}
                                       onChange={e => setSerialNumber(e.target.value)}
                                       placeholder={'Серийный номер'} type="number"/>

                                <div style={{'display': focus ? "block" : "none"}} className={classes.allThingsList}>
                                    {filterList.filter((item) => {
                                        if (item.serialNumber?.includes(serialNumber.toString())) {
                                            return item
                                        }
                                    }).map((item) => {
                                        return (
                                            <div
                                                onClick={() => {
                                                    addItemFilter(item)
                                                }}
                                                className={classes.allThingsListItem}
                                            >
                                                {item.serialNumber}
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>

                            <div className={classes.listFilter}>
                                {list.map((item) => {
                                    return (
                                        <div key={item.serialNumber} className={classes.listFilterItem}>
                                            <div className={classes.listFilterItemName}>{item.serialNumber}</div>
                                            <button className={classes.deleteBtn} onClick={() => {
                                                deleteItem(item)
                                            }}>-
                                            </button>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>}
                </div>
                <div className={classes.version}>rev. 1.4.0</div>
            </div>
        </>
    );
});

export default Main;